import { useLocation, useParams } from 'react-router-dom';
import { OrderDetailModal } from '../components/modals/OrderDetailModal';
import { useOrder } from '../api/hooks';
import { fmtAmt } from '@wave/shared';
import { StatusBadge } from '../components/StatusBadge';
import { ProgressBar } from '../components/ProgressBar';

/**
 * Полноэкранная версия детали — рендерится при прямом переходе на /orders/:id
 * (без backgroundLocation в state). Когда открыта как модалка из списка, этот
 * компонент не маунтится — модалка рисуется поверх предыдущего роута через
 * ModalRoutes (см. App.tsx).
 */
export function OrderDetailPage() {
  const location = useLocation();
  const hasBackground = (location.state as { backgroundLocation?: unknown } | null)?.backgroundLocation;
  if (hasBackground) {
    // Модалка нарисована поверх предыдущего роута; этот компонент не должен показывать содержимое.
    return null;
  }

  // Direct navigation — отрисовываем как полноценную страницу с минимальной шапкой.
  return <DirectDetail />;
}

function DirectDetail() {
  const { id } = useParams<{ id: string }>();
  const { data: order, isLoading, error } = useOrder(id ?? null);

  return (
    <div className="p-6">
      {isLoading && <div className="text-text2">Загрузка…</div>}
      {error && <div className="text-danger">{(error as Error).message}</div>}
      {order && (
        <>
          <div className="mb-4 flex items-center gap-3">
            <h1 className="text-2xl font-semibold">{order.id}</h1>
            <StatusBadge status={order.status} />
            {order.status !== 'reject' && <ProgressBar done={order.progress} />}
          </div>
          <div className="rounded-lg border border-border bg-bg2 p-4">
            <p className="mb-2 text-sm text-text2">
              Откройте в виде модалки из списка заявок, чтобы воспользоваться действиями.
            </p>
            <p>
              Клиент <span className="font-mono">{order.client}</span>: отдаёт{' '}
              <b>{fmtAmt(order.clGiveAmt, order.clGiveCcy)}</b>, получает{' '}
              <b>{fmtAmt(order.clGetAmt, order.clGetCcy)}</b>.
            </p>
            <p>
              Исполнитель <span className="font-mono">{order.executor}</span>: отдаёт нам{' '}
              <b>{fmtAmt(order.exGiveAmt, order.exGiveCcy)}</b>, берёт у нас{' '}
              <b>{fmtAmt(order.exGetAmt, order.exGetCcy)}</b>.
            </p>
          </div>
        </>
      )}
      <OrderDetailModal />
    </div>
  );
}
